import Api from '@/api/Api'

export default {
  fetchAll () {
    return Api().get('AdminService/fetch_all')
  },
  fetchByCountry (body) {
    return Api().post('AdminService/fetch_by_country', body)
  },
  fetchByServiceType (body) {
    return Api().post('AdminService/fetch_by_service_type', body)
  }
}



// WEBPACK FOOTER //
// ./src/api/AdminServiceAPI.js